import styled from 'styled-components';
import { FilterButton, MenuItemContainer } from '../../styles';

export const FilterMenuContainer = styled(MenuItemContainer)`
  position: relative;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
`;

export const ClearAllFiltersButton = styled.button`
  background: none;
  border: none;
  color: #999;
  cursor: pointer;
  font-size: 0.85rem;
  text-decoration: underline;
`;

export const FiltersLoadingMessage = styled.div`
  padding: 2rem;
  text-align: center;
  color: #666;
`;

export const DangerFilterButton = styled(FilterButton)`
  color: #f44336;
`;
